import { FeatureReferenceBinding } from './FeatureReferenceBinding';
import type { FeatureBindingResolveContext, FeatureBindingResolvedValue } from './FeatureReferenceBinding';
// edit/extrude 的总出口经过 SessionBridge 回到绑定工厂，使用此无绑定依赖的解析器避免初始化环。
import { ExtrudeEndTargetResolver } from '../edit/extrude/ExtrudeEndTargetResolver';

/**
 * 拉伸草图点、基准面的稳定引用绑定。
 * 生命周期随特征原型；仅持有纯数据，重建时必须重新解析，不以旧几何兜底。
 */
export class ExtrudeReferenceFeatureBinding extends FeatureReferenceBinding {
  public readonly kind = 'extrude-reference' as const;
  /** @param payload 序列化终止引用。 */
  public constructor(private readonly payload: SerializedExtrudeReferenceFeatureBinding) { super(); }
  /** @returns 与当前绑定隔离的持久快照。 */
  public serialize(): SerializedExtrudeReferenceFeatureBinding { return structuredClone(this.payload); }
  /** @returns 独立绑定实例。 */
  public clone(): ExtrudeReferenceFeatureBinding { return new ExtrudeReferenceFeatureBinding(this.serialize()); }
  /** @param sketchId 草图持久 ID。 @returns 是否依赖该草图。 */
  public dependsOnSketch(sketchId: string): boolean {
    return this.payload.target.kind === 'sketch-point' && this.payload.target.sketchId === sketchId;
  }
  /** @returns 用户基准面的稳定依赖身份。 */
  public collectModelReferenceIds(): string[] {
    return this.payload.target.kind === 'datum-plane' && !this.payload.target.defaultPlaneKind ? [`datum-plane:${this.payload.target.planeId}`] : [];
  }
  /** @param context 当前运行环境。 @returns 最新几何引用；悬空引用抛错终止重建。 */
  public resolve(context: FeatureBindingResolveContext): FeatureBindingResolvedValue {
    return { kind: this.kind, role: this.payload.role, target: new ExtrudeEndTargetResolver().resolveRuntime(this.payload.target, context.viewer.scene) };
  }
}
